import { FC } from "react";

export interface UserTooltipProps {
  defaultInfo: {
    email: string;
    status: boolean;
  };
}

const UserTooltipContent: FC<UserTooltipProps> = ({ defaultInfo }) => (
  <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <span style={{ fontWeight: 600 }}>Email:</span>
      <span>{defaultInfo?.email}</span>
    </div>
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <span style={{ fontWeight: 600 }}>User Status:</span>
      <span style={{ color: defaultInfo?.status ? "green" : "red" }}>
        {defaultInfo?.status ? "Active" : "Inactive"}
      </span>
    </div>
  </div>
);

export default UserTooltipContent;
